import { EMPTY_VALUE_PLACEHOLDER } from "../constants";

/*
 * Given a funding round, return its (possibly) shortened security name.
 * If the security is in the format of 'Common Stock X', display 'Com X'; if it is
 * 'Preferred Stock X', display 'Pref X'; otherwise, display the full security name.
 * If the security is undefined, display a --.
 */
const getSecurityDisplay = (fundingRound) => {
  if (!fundingRound) {
    return EMPTY_VALUE_PLACEHOLDER;
  }

  const { security } = fundingRound;
  if (!security) {
    return EMPTY_VALUE_PLACEHOLDER;
  }

  if (security.startsWith("Common Stock ")) {
    return `Com ${security.split(" ").pop()}`;
  }
  if (
    security.startsWith("Preferred Stock ") ||
    security.startsWith("Preferred Series ")
  ) {
    return `Pref ${security.split(" ").pop()}`;
  }
  return security;
};

export default getSecurityDisplay;
